import { render, staticRenderFns } from "./ModalCongratulation.vue?vue&type=template&id=1ca4a294&scoped=true&"
import script from "./ModalCongratulation.vue?vue&type=script&lang=js&"
export * from "./ModalCongratulation.vue?vue&type=script&lang=js&"
import style0 from "./ModalCongratulation.vue?vue&type=style&index=0&id=1ca4a294&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca4a294",
  null
  
)

export default component.exports